import { inject, Injectable } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { dayjs } from '@shared/utils';

@Injectable()
export class NgbDatepickerAdapterService extends NgbDateAdapter<string> {
    readonly DELIMITER = '-';
    private ngbc = inject(NgbCalendar);

    fromModel(value: string | null): NgbDateStruct | null {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[2], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[0], 10),
            };
        }
        return null;
    }

    toModel(date: NgbDate | null): string | null {
        if (date && this.ngbc.isValid(date)) {
            return dayjs()
                .year(date.year)
                .month(date.month - 1)
                .date(date.day)
                .format('YYYY-MM-DD');
        } else {
            return null;
        }
    }
}

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    readonly DELIMITER = '-';

    parse(value: string): NgbDateStruct | null {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10),
            };
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {
        return date
            ? dayjs()
                  .year(date.year)
                  .month(date.month - 1)
                  .date(date.day)
                  .format('DD-MM-YYYY')
            : '';
    }
}
